import {
    attachRedReviewMetadata,
    findMatchingBlueMappingGroup,
    resolveRedReviewAction,
} from './red-review-mappings';

/**
 * Selects one complete analysis result for the red-review analysis page.
 *
 * The analysis sub-step reviews the blue draft, so its claim feature, evidence,
 * reason and mapping label always stay blue for every review action. Red only
 * contributes review metadata for the support/oppose card. The following
 * revision sub-step applies revise/replace/add/reject to the displayed result.
 *
 * Unknown or transitional actions also stay blue and do not render a verdict.
 */
export const normalizeRedAnalysisMappingGroup = (redGroup: any, blueAllMappings: any[] = []) => {
    const blueGroup = findMatchingBlueMappingGroup(redGroup, blueAllMappings);
    if (!blueGroup) {
        return null;
    }

    const reviewAction = resolveRedReviewAction(redGroup);
    return attachRedReviewMetadata(blueGroup, redGroup, reviewAction);
};
